module.exports = __webpack_public_path__ + "086027b01ec8419d453728927be6b283.svg";